import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateRefresherButtonAriaLabel: {
    defaultMessage: 'Refresh rate',
    description: 'Aria label for the rate refresher button',
    id: 'aq4qk0',
  },
});
